/**
 * Third party libraries
 */
window.$      = window.jQuery = require('jquery');
window.Swiper = require('swiper');
window.Swiper.default.use([ window.Swiper.Navigation, window.Swiper.Pagination, window.Swiper.Autoplay ]);
window.customSelect = require("custom-select").default;

require("@chenfengyuan/datepicker/dist/datepicker.min.js");